import {
    houseSelectorGetByExternalId,
    HouseSelectorModel as APIHouseSelectorModel,
    HouseSelectorObject as APIHouseSelectorObject,
    HouseSelectorView as APIHouseSelectorView,
} from '@bpd-library/utilities';
import { partition } from '@utilities/partition';

import {
    HouseSelectorModel,
    HouseSelectorPointer,
    HouseSelectorPolygon,
    HouseSelectorView,
} from './types';

export const fetchHouseSelectorData = async (
    houseSelectorId: string,
): Promise<HouseSelectorModel | null> => {
    try {
        const data: APIHouseSelectorModel = await houseSelectorGetByExternalId(houseSelectorId);
        return {
            ...data,
            views: data.views?.map<HouseSelectorView>(
                ({ objects, ...view }: APIHouseSelectorView) => {
                    const [polygons, pointers] = partition<
                        APIHouseSelectorObject,
                        HouseSelectorPolygon,
                        HouseSelectorPointer
                    >(objects ?? [], (object) => !!object.polygon);
                    return { ...view, polygons, pointers };
                },
            ),
        };
    } catch (error) {
        console.error('[House Selector] -- data not available');
        return null;
    }
};

export const findPolygonCenterPoint = (
    object: HouseSelectorPolygon,
    options?: { asPercentage: boolean },
) => {
    if (!object.polygon) return;

    let minX = Number.MAX_SAFE_INTEGER,
        minY = Number.MAX_SAFE_INTEGER,
        maxX = 0,
        maxY = 0;

    object.polygon?.forEach(({ x, y }) => {
        if (x && x < minX) minX = x;
        if (x && x > maxX) maxX = x;
        if (y && y < minY) minY = y;
        if (y && y > maxY) maxY = y;
    });

    object.center = {
        x: (minX + maxX) / 2,
        y: (minY + maxY) / 2,
    };

    if (options?.asPercentage) {
        return {
            x: object.center.x! * 100,
            y: object.center.y! * 100,
        };
    }

    return object.center;
};
